import React, { useEffect } from 'react';
import SpeechRecognition, {
  useSpeechRecognition,
} from 'react-speech-recognition';

import { BsFillMicFill, BsMicMuteFill } from 'react-icons/bs';
import PropTypes from 'prop-types';

const Dictaphone = ({ onTranscriptChange }) => {
  const {
    listening,
    transcript,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable,
  } = useSpeechRecognition();

  useEffect(() => {
    if (onTranscriptChange) {
      console.log(transcript);
      onTranscriptChange(transcript);
    }
  }, [transcript, onTranscriptChange]);

  useEffect(() => {
    let timer;
    if (listening) {
      timer = setTimeout(() => {
        SpeechRecognition.stopListening();
      }, 5000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [listening]);

  if (!browserSupportsSpeechRecognition) {
    console.error('Seu navegador não suporta reconhecimento de voz.');

    return (
      <button
        type="button"
        // onClick={SpeechRecognition.startListening}
        style={{
          border: 'none',
          backgroundColor: '#2c405a',
          padding: '0 8px',
          margin: 'auto',
          height: '40px',
          color: '#f59e0b',
        }}
      >
        <BsMicMuteFill size={20} />
      </button>
    );
  }

  if (!isMicrophoneAvailable) {
    return (
      <button
        type="button"
        style={{
          border: 'none',
          backgroundColor: '#2c405a',
          padding: '0 8px',
          margin: 'auto',
          height: '40px',
          color: '#f59e0b',
        }}
      >
        <BsMicMuteFill size={20} />
      </button>
    );
  }

  const numbeRegex = /.*?\d.*?/;

  if (transcript.match(numbeRegex)) {
    console.log('Contem numeros: ', transcript);
  }

  // const handleStartListening = () => {
  //   SpeechRecognition.startListening({ continuous: true, language: 'pt-BR' });
  // };

  return (
    <button
      type="button"
      // onClick={SpeechRecognition.startListening}
      onClick={() =>
        SpeechRecognition.startListening({
          continuous: false,
          language: 'pt-BR',
          interimResults: true,
        })
      }
      style={{
        border: 'none',
        backgroundColor: listening ? '#2c405a' : '#2c405a',
        padding: '0 8px',
        margin: 'auto',
        height: '40px',
        color: listening ? '#22c55e' : '#3b82f6',
        boxShadow: listening ? 'inset 2px 2px 2px 3px #1C2A3C' : 'none',
        transition: '0.5s',
      }}
    >
      <BsFillMicFill size={20} />
    </button>
  );
};

Dictaphone.propTypes = {
  onTranscriptChange: PropTypes.func,
};

Dictaphone.defaultProps = {
  onTranscriptChange: () => {},
};

export default Dictaphone;
